"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = defaultValue => {
  const [state, setState] = _react.default.useState(defaultValue);
  const open = _react.default.useCallback(e => {
    if (e && 'target' in e) {
      setState(e.target);
    }
  }, []);
  const close = _react.default.useCallback(() => {
    setState(null);
  }, []);
  return {
    isOpen: Boolean(state),
    anchorEl: state,
    close,
    open
  };
};
exports.default = _default;